module.exports = __webpack_public_path__ + "static/media/cluster_7.49fd862d.webp";